import React, { useState } from "react";
import { Text, Button } from "@pentabd/ui";
import "./style.scss";

export const ExpandedText = ({
  text,
  maxLength,
}: {
  text: string,
  maxLength: number,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const tranketText = text.slice(0, maxLength);
  const shouldShowButton = text.length > maxLength;
  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };
  return (
    <Text>
      {isExpanded ? text : tranketText}{" "}
      <span onClick={toggleExpanded}>
        {shouldShowButton && (
          <span>
            <button onClick={toggleExpanded} className="expanded-text">
              {isExpanded ? "See Less" : "... See More"}
            </button>
          </span>
        )}{" "}
      </span>{" "}
    </Text>
  );
};
